import React, { useEffect, useState } from "react";
import Sidebar, { SidebarContent } from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";
import SearchPalette from "@/components/layout/SearchPalette";
import DemoBanner from "@/components/DemoBanner";
import TrialBanner from "@/components/TrialBanner";
import PasswordChangeBanner from "@/components/PasswordChangeBanner";
import OnboardingModal from "@/components/OnboardingModal";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export default function AppLayout({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem("athlynx_sidebar_collapsed") === "1"; } catch { return false; }
  });
  const toggleCollapsed = () => setCollapsed((c) => {
    try { localStorage.setItem("athlynx_sidebar_collapsed", c ? "0" : "1"); } catch { /* private mode */ }
    return !c;
  });

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setSearchOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar collapsed={collapsed} onToggleCollapse={toggleCollapsed} />
      <div className={collapsed ? "lg:pl-[68px] min-w-0 transition-[padding] duration-200" : "lg:pl-[232px] min-w-0 transition-[padding] duration-200"}>
        <Topbar onMenu={() => setDrawerOpen(true)} onSearch={() => setSearchOpen(true)} />
        <DemoBanner />
        <PasswordChangeBanner />
        <TrialBanner />
        <OnboardingModal />
        <main>{children}</main>
      </div>

      {/* Mobile navigation drawer */}
      <Sheet open={drawerOpen} onOpenChange={setDrawerOpen}>
        <SheetContent side="left" className="w-[280px] p-0 bg-surface" data-testid="mobile-nav-drawer">
          <SheetHeader className="sr-only">
            <SheetTitle>Navigation</SheetTitle>
          </SheetHeader>
          <SidebarContent onNavigate={() => setDrawerOpen(false)} showSelector />
        </SheetContent>
      </Sheet>

      <SearchPalette open={searchOpen} onOpenChange={setSearchOpen} />
    </div>
  );
}
